import { type GridListComponentMapProps, GridListLayout } from "@client/content/controls/GridList/component";
import { rootContainerPropsSelector } from "@client/content/selectors";
import { TargetSelector, combinedSettingsSelector, createShallowEqualSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import { type EventItemProps } from "./Content/Event/component";
import EventItem from "./Content/Event/container";

export const eventIdsSelector = (state: AppState) => state.events.items.map((item) => item.id);

export const makeGridListPropsSelector = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["gap", "columns"]);

  return createShallowEqualSelector(
    [settingsSelector, eventIdsSelector, rootContainerPropsSelector],
    (settings, eventIds, { id, ...rootContainerProps }): GridListComponentMapProps<EventItemProps> => ({
      page: 1,
      isLoading: false,
      items: eventIds,
      columns: settings.columns,
      gutter: parseFloat(settings.gap),
      layout: GridListLayout.Grid,
      itemProps: {
        ...rootContainerProps,
        parentId: id
      },
      ItemComponent: EventItem
    })
  );
};
